import { InvestmentObjectiveType, PlannedServiceType } from 'api/types/entity';
import { LegalClientInvestmentPurposeAndNatureParam } from 'api/types/params';

import { InvestmentPurposeAndNatureFormType } from '../../forms/investmentPurposeAndNatureForm';

export const getInvestmentPurposeAndNatureParam = (
  values: InvestmentPurposeAndNatureFormType
): LegalClientInvestmentPurposeAndNatureParam => ({
  otherInvestmentObjective:
    values.investmentPurposeAndNature.investmentObjectives.find(
      (v) => v.value === InvestmentObjectiveType.Other
    )
      ? values.investmentPurposeAndNature.otherInvestmentObjective
      : null,

  otherPlannedServices: values.investmentPurposeAndNature.plannedServices.find(
    (v) => v.value === PlannedServiceType.Other
  )
    ? values.investmentPurposeAndNature.otherPlannedServices
    : null,
  investmentDuration:
    values.investmentPurposeAndNature.investmentDuration.value,
  investmentObjectives:
    values.investmentPurposeAndNature.investmentObjectives?.map((v) => v.value),
  plannedServices: values.investmentPurposeAndNature.plannedServices?.map(
    (v) => v.value
  ),
});
